import React from "react";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import EditIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import SimpleReactValidator from 'simple-react-validator';
import axios from "axios";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY

class UserListSA extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: "",
      firstName: "",
      lastName: "",
      emailId: "",
      phoneNumber: "",
      password: "",
      statusUpdate: false,
      statusEdit: {},
      editStatus: false,
      userID: 0
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });

  }

  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    axios.get(process.env.REACT_APP_NODE_ENV + "/api/users/fetchAll", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    })
      .then(res => {
        let data = CryptoJS.AES.decrypt(res.data, key)
        let decData = JSON.parse(data.toString(CryptoJS.enc.Utf8))
        this.setState({ userData: decData, loader: false })
      }).catch(error => {
        console.log(error)
        this.setState({ userData: [], loader: false })
      })
  }

  editStatusHandler = value => {
    const doesToggle = this.state.editStatus;
    this.setState({ statusEdit: value, editStatus: !doesToggle });
    this.setState({ firstName: value.userFirstName });
    this.setState({ lastName: value.userLastName })
    this.setState({ emailId: value.userEmail });
    this.setState({ phoneNumber: value.userPhoneNumber })
    this.setState({ password: value.userPassword })
  };

  popUpCancel = () => {
    this.setState({ editStatus: false, statusUpdate: false });
  }

  save = () => {
    if (this.validator.allValid()) {
      this.setState({ editStatus: false })
      let postUserData = "";
      if (this.state.statusUpdate) {
        postUserData = {
          id: this.state.statusEdit.id, userFirstName: this.state.firstName,
          userLastName: this.state.lastName,
          userEmail: this.state.emailId, userPhoneNumber: this.state.phoneNumber,
          userPassword: this.state.password
        };
        postUserData = CryptoJS.AES.encrypt(JSON.stringify(postUserData), key).toString()
        fetch(process.env.REACT_APP_NODE_ENV + '/api/users/updateUser', {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify({ data: postUserData })
        }).then((res) => res.json())
          .then((data) => { this.componentDidMount() })
          .catch((err) => console.log(err))
      }
      // else {
      //   this.componentDidMount();
      // }
    }
  }

  handleEditFormFields = (event) => {
    this.validator.showMessageFor(event.target.name)
    this.setState({ statusUpdate: true })
    switch (event.target.id) {
      case "firstName":
        this.setState({ firstName: event.target.value });
        break;
      case "lastName":
        this.setState({ lastName: event.target.value });
        break;
      case "emailId":
        this.setState({ emailId: event.target.value });
        break;
      case "phoneNumber":
        this.setState({ phoneNumber: event.target.value });
        break;
      case "password":
        this.setState({ password: event.target.value });
        break;
      default: break;
    }
  }

  render() {

    let dataArr = [];
    this.state.userData.map((data) => {
      let variant = "";
      // if (data.userType === "Customer") { variant = "success" }
      // else if (data.userType === "Partner") { variant = "primary" }
      // else { variant = "" }
      let mdData = {
        key: data.id,
        Name: data.userFirstName + ' ' + data.userLastName, MobileNumber: data.userPhoneNumber, UserType: data.userType, UserEmail: data.userEmail,
        actions: data
      };
      dataArr.push(mdData)
      return null
    });


    const columns = [
      {
        name: "Name",
        label: "Name",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "MobileNumber",
        label: "Mobile Number",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "UserEmail",
        label: "Email Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "UserType",
        label: "User Type",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "actions",
        label: "Actions",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <><Tooltip title="Edit Details"><IconButton>
                <EditIcon onClick={() => this.editStatusHandler(value)} /></IconButton></Tooltip> </>
            );
          }
        }
      }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'User List.csv',
      },
      // onRowsDelete: (rowsDeleted) => {
      //   for (var key in rowsDeleted.data) {
      //     console.log(rowsDeleted.data[key].index)
      //     this.delete(dataArr[rowsDeleted.data[key].index].id)
      //   }
      // }
    };

    let statusEdit = (
      <>
        <div className="col-lg-4">
          <label><b>First Name</b></label>
          <input className="form-control" required name="First Name" id="firstName" placeholder="First Name" value={this.state.firstName} onChange={this.handleEditFormFields} />
          {
            this.validator.message('First Name', this.state.firstName, 'required|alpha')
          }
        </div>
        <div style={{ paddingTop: "20px" }} className="col-lg-4">
          <label><b>Last Name</b></label>
          <input className="form-control" required name="Last Name" id="lastName" placeholder="Last Name" value={this.state.lastName} onChange={this.handleEditFormFields} />
          {
            this.validator.message('Last Name', this.state.lastName, 'required|alpha')
          }
        </div>
        <div className="col-lg-4">
          <label><b>E-mail</b></label>
          <input type="email" className="form-control" required name="Email Id" id="emailId" placeholder="E-mail" value={this.state.emailId} onChange={this.handleEditFormFields} />
          {
            this.validator.message('E-mail', this.state.emailId, 'email')
          }
        </div>
        <div style={{ paddingTop: "20px" }} className="col-lg-4">
          <label><b>Phone Number</b></label>
          <input className="form-control" required name="Phone Number" id="phoneNumber" placeholder="Phone Number" value={this.state.phoneNumber} onChange={this.handleEditFormFields} />
          {
            this.validator.message('Phone Number', this.state.phoneNumber, 'required|phone|max:13')
          }
        </div>
        <div style={{ paddingTop: "20px" }} className="col-lg-4">
          <label><b>Password</b></label>
          <input className="form-control" required name="Password" id="password" placeholder="Password" value={this.state.password} onChange={this.handleEditFormFields} />
          {
            this.validator.message('Password', this.state.password, 'required|max:20|min:8')
          }
        </div>
      </>)

    let userListTable = (<Card>
      <Card.Body>
        <div style={{ marginTop: "10px" }}>
          {/* <Button className="float-right"
            variant="outline-success"
            style={{ marginTop: "10px", marginRight: "10px", width: "150px" }}
            onClick={() => this.nextPath("/user/user-create")
            }
          >
            Add User
                </Button> */}
          <MUIDataTable
            title={"User List"}
            data={dataArr}
            columns={columns}
            options={options} />
        </div>
      </Card.Body>
    </Card>);

    let editStatuss = null;
    if (this.state.editStatus) {
      editStatuss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Edit Details for - {this.state.firstName + " " + this.state.lastName}</ModalHeader>
              <ModalBody>
                {statusEdit}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>User Details</Breadcrumb.Item>
        </Breadcrumb>
        <div>
          {editStatuss}
        </div>
        {userListTable}
      </>
    );
  }
}

export default withRouter(UserListSA);
